import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "photos_title_banner_component",
  class: "text-white"
}
const _hoisted_2 = { class: "d-flex justify-content-center align-items-start" }
const _hoisted_3 = {
  id: "photos-home-carousel",
  class: "carousel slide",
  "data-bs-ride": "carousel"
}
const _hoisted_4 = { class: "carousel-inner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonArrowCarouselPrevious = _resolveComponent("ButtonArrowCarouselPrevious")!
  const _component_ButtonArrowCarouselNext = _resolveComponent("ButtonArrowCarouselNext")!
  const _component_PhotoListHomePage = _resolveComponent("PhotoListHomePage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ButtonArrowCarouselPrevious, {
        dataBsTarget: "#photos-home-carousel",
        dataBsSlide: "prev",
        numSlides: _ctx.photos.length
      }, null, 8, ["numSlides"]),
      _createVNode(_component_ButtonArrowCarouselNext, {
        dataBsTarget: "#photos-home-carousel",
        dataBsSlide: "next",
        numSlides: _ctx.photos.length
      }, null, 8, ["numSlides"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.photos, (photosForPage, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(_ctx.getClassCarouselItem(index))
          }, [
            _createVNode(_component_PhotoListHomePage, { photos: photosForPage }, null, 8, ["photos"])
          ], 2))
        }), 128))
      ])
    ])
  ]))
}